export type ValidAccountType = 'educator' | 'student';

/**
 * The new signup flow only supports two account types. Any other `?accountType=` query-param
 * value (an unknown role, a typo, or tampering) maps to `null` so {@link SignUpPage} falls back
 * to account-type selection instead of rendering the signup form for an unrecognized type.
 */
export function getValidAccountType(accountType?: string | null): ValidAccountType | null {
  return accountType === 'educator' || accountType === 'student' ? accountType : null;
}
